// import React from 'react';
// import {
//   Menu,
//   MenuItem,
// } from '@mui/material';
// import Can from '../permissions/Can';

// const LeadActionsMenu = ({
//   anchorEl,
//   selectedLead,
//   onClose,
//   onViewLead,
//   onEditLead,
//   onCreateDba,
//   onEditDba,
//   onOpenStatusDialog,
//   onOpenAssignDialog,
//   onOpenShareDialog,
//   onOpenAttachmentsDialog,
//   onOpenIssueDialog,
//   onOpenCreateCustomerDialog,
//   onOpenAssignedUsersDialog,
//   onDeleteLead,
//   permissions = {}

// }) => {


//   const {
//     canViewListLead = true,
//     canEditLeads = true,
//     canChangeLeadStatus = true,
//     canAssignLeads = true,
//     canDeleteLeads = true,
//     canCreateShareableLink = true,
//     canViewAssignedUsers = true,
//      canCreateCustomer = true
//   } = permissions;

//   const handleView = () => {
//     onViewLead(selectedLead.id);
//     onClose();
//   };

//   const handleEdit = () => {
//     onEditLead(selectedLead.id);
//     onClose();
//   };

//   const handleCreateDbaClick = () => {
//     onCreateDba(selectedLead.id);
//     onClose();
//   };

//   const handleEditDbaClick = () => {
//     onEditDba(selectedLead.dba.id);
//     onClose();
//   };

//   const handleDelete = () => {
//     onDeleteLead(selectedLead);
//     onClose();
//   };

//   const handleCreateCustomerClick = () => {
//     onOpenCreateCustomerDialog(selectedLead.id); // ✅ Correct - pass entire lead object
//     onClose();
//   };

//   return (
//     <Menu
//       anchorEl={anchorEl}
//       open={Boolean(anchorEl)}
//       onClose={onClose}
//     >
//       <Can permission="lead-view">
//         <MenuItem onClick={handleView}>View</MenuItem>
//       </Can>
//       <Can permission="lead-edit">
//         <MenuItem onClick={handleEdit}>Edit</MenuItem>
//       </Can>

//       {selectedLead?.dba?.id ? (
//         <Can permission="dba-edit">
//           <MenuItem onClick={handleEditDbaClick}>
//             Edit DBA
//           </MenuItem>
//         </Can>
//       ) : (
//         <Can permission="dba-create">
//           <MenuItem onClick={handleCreateDbaClick}>
//             Create DBA
//           </MenuItem>
//         </Can>
//       )}
//       <Can permission="lead-status">
//         <MenuItem onClick={onOpenStatusDialog}>Change Status</MenuItem>
//       </Can>
//       <Can permission="lead-assign-user">
//         <MenuItem onClick={onOpenAssignDialog}>Assign to User</MenuItem>
//       </Can>
//       <Can permission="shareable-link-create">
//         <MenuItem onClick={onOpenShareDialog}>Create Shareable URL</MenuItem>
//       </Can>
//       <Can permission="lead-view">
//         <MenuItem onClick={onOpenAttachmentsDialog}>Show All Attachments</MenuItem>
//       </Can>
//       <Can permission="lead-assigned-users-list">
//         <MenuItem onClick={onOpenAssignedUsersDialog}>Assigned Users History</MenuItem>
//       </Can>
//       <Can permission="user-create">
//         <MenuItem onClick={handleCreateCustomerClick}>
//           Create Customer
//         </MenuItem>
//       </Can>
//       <Can permission="issue-create">
//         <MenuItem onClick={onOpenIssueDialog}>Create An Issue</MenuItem>
//       </Can>
//       <Can permission="lead-delete">
//         <MenuItem onClick={handleDelete} sx={{ color: 'error.main' }}>
//           Delete
//         </MenuItem>
//       </Can>
//     </Menu>
//   );
// };

// export default LeadActionsMenu;

import React from 'react';
import {
  Menu,
  MenuItem,
} from '@mui/material';
import Can from '../permissions/Can';

const LeadActionsMenu = ({
  anchorEl,
  selectedLead,
  onClose,
  onViewLead,
  onEditLead,
  onCreateDba,
  onEditDba,
  onOpenStatusDialog,
  onOpenAssignDialog,
  onOpenShareDialog,
  onOpenAttachmentsDialog,
  onOpenIssueDialog,
  onOpenCreateCustomerDialog,
  onOpenAssignedUsersDialog,
  onDeleteLead,
  permissions = {}
}) => {
  const {
    canViewListLead = true,
    canEditLeads = true,
    canChangeLeadStatus = true,
    canAssignLeads = true,
    canDeleteLeads = true,
    canCreateShareableLink = true,
    canViewAssignedUsers = true,
    canCreateCustomer = true
  } = permissions;

  const handleView = () => {
    onViewLead(selectedLead.id);
    onClose();
  };

  const handleEdit = () => {
    onEditLead(selectedLead.id);
    onClose();
  };

  const handleCreateDbaClick = () => {
    onCreateDba(selectedLead.id);
    onClose();
  };

  const handleEditDbaClick = () => {
    onEditDba(selectedLead.dba.id);
    onClose();
  };

  const handleDelete = () => {
    onDeleteLead(selectedLead);
    onClose();
  };

  const handleCreateCustomerClick = () => {
    // ✅ FIX: Call onOpenCreateCustomerDialog FIRST, then onClose
    onOpenCreateCustomerDialog(selectedLead);
    // onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
    >
      <Can permission="lead-view">
        <MenuItem onClick={handleView}>View</MenuItem>
      </Can>
      <Can permission="lead-edit">
        <MenuItem onClick={handleEdit}>Edit</MenuItem>
      </Can>

      {selectedLead?.dba?.id ? (
        <Can permission="dba-edit">
          <MenuItem onClick={handleEditDbaClick}>
            Edit DBA
          </MenuItem>
        </Can>
      ) : (
        <Can permission="dba-create">
          <MenuItem onClick={handleCreateDbaClick}>
            Create DBA
          </MenuItem>
        </Can>
      )}
      <Can permission="lead-status">
        <MenuItem onClick={onOpenStatusDialog}>Change Status</MenuItem>
      </Can>
      <Can permission="lead-assign-user">
        <MenuItem onClick={onOpenAssignDialog}>Assign to User</MenuItem>
      </Can>
      <Can permission="shareable-link-create">
        <MenuItem onClick={onOpenShareDialog}>Create Shareable URL</MenuItem>
      </Can>
      <Can permission="attachment-view">
        <MenuItem onClick={onOpenAttachmentsDialog}>Show All Attachments</MenuItem>
      </Can>
      <Can permission="lead-assigned-users-list">
        <MenuItem onClick={onOpenAssignedUsersDialog}>Assigned Users History</MenuItem>
      </Can>
      <Can permission="customer-create">
        <MenuItem onClick={handleCreateCustomerClick}>
          Create Customer
        </MenuItem>
      </Can>
      <Can permission="issue-create">
        <MenuItem onClick={onOpenIssueDialog}>Create An Issue</MenuItem>
      </Can>
      <Can permission="lead-delete">
        <MenuItem onClick={handleDelete} sx={{ color: 'error.main' }}>
          Delete
        </MenuItem>
      </Can>
    </Menu>
  );
};

export default LeadActionsMenu;